import * as React from 'react';

// COMPONENTS
import Button from '../../components/Button';
import LoginForm from './LoginForm';

// ICONS
import { ReactComponent as MainLogo } from '../../assets/img/logo-main.svg';

// TYPES
import { AccountRegistrationCommand } from '../../api/models';
import { closeModalType } from '../../components/GlobalModal';

interface LoginModalTypes {
	organisationIdentifier?: AccountRegistrationCommand['organisationIdentifier'];
	paymentPlanId?: AccountRegistrationCommand['paymentPlanId'];
	profileType?: AccountRegistrationCommand['profileType'];
	previousUrl?: string;
	returnUrl?: string;
	closeModal?: closeModalType;
}

export const LoginModal: React.FC<LoginModalTypes> = ({
	organisationIdentifier,
	paymentPlanId,
	profileType,
	previousUrl,
	returnUrl = '/dashboard',
	closeModal
}) => {
	return (
		<div className="modal-panel">
			<div className="panel panel-login">
				<div className="header">
					{!!closeModal && (
						<Button className="btn-text" onClick={closeModal}>
							Close
						</Button>
					)}

					<MainLogo className="logo" />

					<h1 className="h3">Log in to your ChildAware account&nbsp;to&nbsp;continue</h1>
				</div>

				<LoginForm
					organisationIdentifier={organisationIdentifier}
					paymentPlanId={paymentPlanId}
					profileType={profileType}
					previousUrl={previousUrl}
					returnUrl={returnUrl}
				/>
			</div>
		</div>
	);
};

export default LoginModal;
